import { useEffect, useState } from "react";
import axios from "axios";

import { getApiUrl } from "../core/config/api.js";
import { Window } from "../contexts";

const normalizeCategories = (categories) => {
  if (!Array.isArray(categories) || categories.length === 0) {
    return [];
  }

  if (categories[0]?.id !== undefined) {
    return categories;
  }

  return categories.map((category) => ({
    id: category,
    name: category,
  }));
};

export default function useCategories() {
  const [categories, setCategories] = useState(() =>
    normalizeCategories(Window.CATEGORIES)
  );

  useEffect(() => {
    if (categories.length) {
      return undefined;
    }

    const cached = normalizeCategories(Window.CATEGORIES);
    if (cached.length) {
      setCategories(cached);
      return undefined;
    }

    let cancelled = false;

    axios.get(getApiUrl("/api/categories")).then((response) => {
      if (cancelled || !response.data?.length) {
        return;
      }

      setCategories(normalizeCategories(response.data));
    });

    return () => {
      cancelled = true;
    };
  }, [categories.length]);

  return categories;
}
